<template>
    <div>
        There are {{races.length}} races in the game
        <br/><br/>       

        <br/><br/><br/>
        <div v-if="specialSelection == 'None'">
            <h1 style="color:cornflowerblue">Races:</h1>                 
            <table style="width:100%">
                <tr>
                    <th>Race</th>
                    <th>Description</th>                
                </tr>
                <tr v-for="race in races" :key="race.name"> 
                    <td :id="`${race.name}`" style="padding-left:4px; padding-right:4px; text-align:center">{{race.name}}</td>                    
                    <td style="padding-left:4px">{{race.longDesc}}<span v-if="race.hasSpecialItems"><br/><br/><button style="color:blue; background:none; border:none;"  @click="setSpecialSelections(race)">Click to See Race Special Selection</button></span></td>
                </tr>
            </table>  
        </div>
        <div v-else id="top">
            <v-btn text class="pa-0" style="position:fixed; width:50px;right:25px;bottom:50px" @click="clearSpecialSelection"><v-img style="width:50px;"  :src="require('../../../assets/Mini_skip reversed.png')"></v-img></v-btn>
            <h1 style="color:cornflowerblue">{{specialSelection.name}}:</h1>                 
            <table style="width:100%">
                <tr>
                    <th >Name</th>
                    <th v-if="specialSelectionItems[0].type">Type</th>
                    <th>Description</th>                
                </tr>
                <tr v-for="item in specialSelectionItems" :key="item.name"> 
                    <td style="padding-left:4px; padding-right:4px; text-align:center">{{item.name}}</td>
                    <td v-if="specialSelectionItems[0].type" style="padding-left:4px; padding-right:4px; text-align:center">{{item.type}}</td>
                    <td style="padding-left:4px">{{item.description}}</td>
                </tr>
            </table>  
        </div>
        <v-icon style="position:fixed; right:16px; bottom:16px; color:cornflowerblue" outlined large @click="scrollTo('top')">mdi-arrow-up-circle</v-icon>
    </div>
</template>
<script>
//
import {races} from "../../../play/data"

export default {
  components: {
  },
  props:{
    
  },
  mounted(){
    let params = new URLSearchParams(location.search)
    let perkList = params.get('perkList')
    if(perkList){
        let race = races.find(race=> race.name == perkList)
        this.setSpecialSelections(race)
    } 

  },
  data(){
      return{
          races:[...races],
          specialSelection:"None",
          specialSelectionItems:[],
      }
  },
  methods:{
    scrollTo(id){
        if(id == 'top'){
            window.scrollTo({top: 0, behavior: 'instant'});
        }else{
            let element = document.getElementById(id);
            let y = element.getBoundingClientRect().top - 64;
            window.scrollTo({top: y, behavior: 'smooth'});
        }
    },  

    capitalize(str){  
        for(let x = 0; x < str.length; x++){
            if(str[x].toUpperCase() == str[x]){
                str = str.substring(0,x) + " " + str.substring(x,str.length)
                break;
            }
        }            
        let newStr = str[0].toUpperCase() + str.substring(1)
        return newStr
      },

      setSpecialSelections(race){
        this.specialSelection = race
        this.specialSelectionItems = race.getSpecialItemList(race)
        this.$nextTick(()=>{
            this.scrollTo("top")
        })
        window.history.replaceState(null, null, "?type=Races&perkList=" + race.name)
      },

      clearSpecialSelection(){
        let name = this.specialSelection.name
        this.$nextTick(()=>{
            window.scrollTo({top: 0, behavior: 'instant'});
            this.$nextTick(()=>{
                this.scrollTo(name)
            })           
        })
        window.history.replaceState(null, null, "?type=Races")
        this.specialSelection = 'None'
      }
  }

}
</script>
<style scoped>
table, th, td {
  border:1px solid black;
}
</style>